'use client';

import type { ReactNode } from 'react';

import ContentCarousel, { type ContentCarouselProps } from '../../components/ContentCarousel.js';

export type {
  ContentCarouselProps as ArticleCarouselClientProps,
  ContentCarouselSlide as ArticleCarouselSlide,
} from '../../components/ContentCarousel.js';

export default function ArticleCarouselClient(props: ContentCarouselProps): ReactNode {
  return <ContentCarousel {...props} />;
}
